;(function module() {
  angular.module('app.ui.form.ctrls').controller('TimePickerController', [
    '$log',
    function controller($log) {
      let vm = this
      vm.selectedTime = new Date()
      vm.hourStep = 1
      vm.minStep = 1
      vm.options = {
        hourStep: [1, 2, 3],
        minStep: [1, 5, 10, 15, 25, 30],
      }
      vm.isMeridian = true

      vm.toggleMode = () => {
        vm.isMeridian = !vm.isMeridian
        return vm.isMeridian
      }

      vm.update = () => {
        var d
        d = new Date()
        d.setHours(14)
        d.setMinutes(0)
        vm.selectedTime = d
        return vm.selectedTime
      }

      vm.changed = () => {
        return $log.info('Time changed to: ' + vm.selectedTime)
      }

      vm.clear = () => {
        vm.selectedTime = undefined
        return vm.selectedTime
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/shared/directives/date-modal/time-picker.ctrl.js